import React from "react";
import { useDashboardCounts } from "../../hooks/useDashboardCounts";
import LoadingSpinner from '../ui/LoadingSpinner';

const UnAcknowledgedAlarmsCard: React.FC = () => {
    const { counts, loading } = useDashboardCounts();
    const now = new Date();
    const monthLabel = now.toLocaleString(undefined, { month: 'long', year: 'numeric' });

    const isLoading = loading;

    if (isLoading) {
        return (
            <div className="card">
                <div className="card__content">
                    <LoadingSpinner message="Loading…" />
                </div>
            </div>
        );
    }

    return (
        <div className="card card__unacknowledged-alarms" aria-live="polite">
            <div className="card__icon--alarm" />
            <div className="card__content">
                <h6>{monthLabel}</h6>
                <h2>{(counts?.activeUnack ?? 0).toLocaleString()}</h2>
                <span>Unacknowledged Alarms</span>
            </div>
        </div>
    );
};

export default UnAcknowledgedAlarmsCard;